import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledObserverName = styled.p`
    font-size: 16px;
    font-weight: 700;
`;

export const StyledTag = styled(Tag)`
    margin-right: 2px
`;

export const StyledTimelineContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 280px;
`;